import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from '../services/auth.service';

@Directive({
  selector: '[authGroup]'
})
export class AuthGroupDirective {

  constructor(
    private _templateRef: TemplateRef<any>,
    private _viewContainer: ViewContainerRef,
    private _auth: AuthService) { }

  @Input() set authGroup(groups: Array<string>) {
    if (this.hasAccess(groups)) {
      this._viewContainer.createEmbeddedView(this._templateRef);
    } else {
      this._viewContainer.clear();
    }
  }

  hasAccess(groups: Array<string>): boolean {
    let roles = this._auth.getRoles();
    for (let x = 0; x < roles.length; x++) {
      if (groups.indexOf(roles[x]) > -1) {
        return true;
      }
    }
    return false;
  }
}
